import { useContext } from "react";
import { Link } from "react-router-dom";
import { CookieContext } from "./CookieContext";

const CookieBanner = () => {
  const { consent, saveConsent } = useContext(CookieContext);

  if (consent) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        <h3>Szanujemy Twoją prywatność</h3>

        <p>
          Używamy niezbędnych plików cookies, aby serwis TwojaOpiekunka.pl
          działał prawidłowo. Za Twoją zgodą możemy również korzystać z cookies
          analitycznych i marketingowych.
        </p>

        <div style={styles.buttons}>
          <button
            style={styles.primaryButton}
            onClick={() =>
              saveConsent({
                analytics: true,
                marketing: true,
              })
            }
          >
            Akceptuj wszystkie
          </button>

          <button
            style={styles.button}
            onClick={() =>
              saveConsent({
                analytics: false,
                marketing: false,
              })
            }
          >
            Tylko niezbędne
          </button>

          <Link to="/cookies" style={styles.settingsButton}>
            Ustawienia cookies
          </Link>
        </div>

        <p style={styles.info}>
          Więcej informacji znajdziesz w{" "}
          <Link to="/polityka-prywatnosci">Polityce prywatności</Link>.
        </p>
      </div>
    </div>
  );
};

const styles = {
  banner: {
    position: "fixed",
    bottom: 0,
    left: 0,
    width: "100%",
    background: "#222",
    color: "#fff",
    padding: "18px 20px",
    zIndex: 9999,
    boxSizing: "border-box",
  },

  content: {
    maxWidth: "1100px",
    margin: "0 auto",
  },

  buttons: {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    marginTop: "15px",
  },

  button: {
    padding: "10px 18px",
    borderRadius: "5px",
    border: "1px solid #fff",
    background: "#fff",
    color: "#222",
    cursor: "pointer",
  },

  primaryButton: {
    padding: "10px 18px",
    borderRadius: "5px",
    border: "1px solid #006400",
    background: "#006400",
    color: "#fff",
    cursor: "pointer",
  },

  settingsButton: {
    display: "inline-block",
    padding: "10px 18px",
    borderRadius: "5px",
    border: "1px solid #fff",
    color: "#fff",
    textDecoration: "none",
  },

  info: {
    marginTop: "12px",
    fontSize: "13px",
  },
};

export default CookieBanner;
